import React from "react";

import VentanaVenta from "./ventanaVenta";

/*
	Estado de Cuenta → «Cargar Productos»: es la misma ventana que Ventas › «+ Nueva Venta» (Módulos Claros, 2026-11-01),
	con el alumno fijo y el cargo con from=accountStatement (sale_channel "account"). Al cargar se cierra, como antes.
*/
export interface CargarProductosProps {
	campusId: number;
	studentId: number;
	currency: string;
	onClose: () => void;
	onDone: (total: number, count: number) => void;
}

const CargarProductos: React.FC<CargarProductosProps> = ({ campusId, studentId, currency, onClose, onDone }) =>
	<VentanaVenta campusId={campusId} studentId={studentId} currency={currency} from="accountStatement" onClose={onClose} onDone={onDone} />;

export default CargarProductos;
